import { Spin, Typography } from 'antd';
import styled from 'styled-components';
import { useState } from 'react';
import { api } from 'utils/apiRoutes';
import { LoadingOutlined } from '@ant-design/icons';

interface ForgotPasswordProps {
  changeTab: (tab: string) => void;
}
const ForgotPassword = ({ changeTab }: ForgotPasswordProps) => {
  const [value, setValue] = useState<string>('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  async function sendRequest() {
    setLoading(true);
    const res = await fetch(api.send_request, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username: value }),
    }).then((res) => res.json());

    if (res['message'] === 'Forgot password email sent.') {
      setLoading(false);
      changeTab('3');
      sessionStorage.setItem('username', value);
    } else {
      setError(res['username']);
      setLoading(false);
    }
  }

  return (
    <>
      <div className={'has-text-centered'}>
        <p
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#AEAEAE',
            fontSize: 14,
          }}
        >
          Enter your email account and we’ll send you a code <br />
          to reset your password.
        </p>
      </div>
      <RequestForm>
        <MailInput
          style={{ border: error !== '' ? '1px solid #ed2024' : 'none' }}
        >
          <span className={'mail-input-icon'} style={{ paddingTop: 5 }}>
            <img alt={'icon'} src={'/icons/pass_user.svg'} />
          </span>
          <input
            type={'text'}
            value={value}
            onChange={(e) => {
              if (error !== '') {
                setError('');
              }
              setValue(e.target.value);
            }}
            style={{ border: 'none', width: '100%' }}
            placeholder={'Email'}
          />
        </MailInput>
        <span style={{ color: '#ed2024' }}>{error && error}</span>
        <SubmitButton
          style={{
            background: value === '' ? '#E4E4E4' : '#0E3063',
            cursor: value === '' ? 'not-allowed' : 'pointer',
          }}
          disabled={value === '' || loading}
          onClick={sendRequest}
        >
          <span style={{ color: '#fff' }}>
            {loading ? <LoadingOutlined /> : 'Recover Password'}
          </span>
        </SubmitButton>
      </RequestForm>
    </>
  );
};
const RequestForm = styled.div`
  max-width: 446px;
  margin-top: 2em;
  margin-left: 3.5em;
`;
const MailInput = styled.div`
  background: #efeef4;
  display: flex;
  padding: 5px;
  gap: 5px;
  height: 48px;
  border-radius: 10px;
  input {
    background: #efeef4;
    &:focus {
      outline: none;
    }
  }
`;
const SubmitButton = styled.button`
  width: 100%;
  height: 48px;
  margin-top: 1.6em;
  border: none;
  border-radius: 10px;
`;
export default ForgotPassword;
